import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable, action } from 'mobx'
import { formatDate, stringifyDate } from '@atheneum/api/dist/lib'
import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import { DatePicker } from '@components/DatePicker'
import { Dropdown } from '@components/Autocomplete'
import propTypes from 'prop-types'
import InfoBox from '@components/InfoBox'
import  { capi } from '@atheneum/api'

class EPLCancellationModal extends Component {
  static defaultProps = {
    shouldCloseOnOverlayClick: false,
    showCloseIcon: true
  }
  constructor(props) {
    super(props)
    const SUBMITTED_EPL_STATUS = 5
    extendObservable(this, {
      shouldOverrideDate: false,
      defaultDate: new Date(),
      selectedDate: null,
      eplStatusComment: null,
      error: null,
      statusPreviouslySubmitted:
        !!props.eplModel?.epl?.eplStatusId === SUBMITTED_EPL_STATUS
    })
  }

  componentDidMount() {
    if (window && window.outerWidth < 768) {
      document
        .querySelector('body')
        .setAttribute(
          'style',
          'min-width: 0 !important; width: auto !important;'
        )
      document
        .querySelector('html')
        .setAttribute(
          'style',
          'min-width: 0 !important; width: auto !important;'
        )
      document.querySelector('.modal__content').scrollIntoView()
    }
  }

  componentWillUnmount() {
    document
      .querySelector('body')
      .setAttribute(
        'style',
        'min-width: 1920px !important; width: auto !important;'
      )
    document
      .querySelector('html')
      .setAttribute(
        'style',
        'min-width: 1920px !important; width: auto !important;'
      )
  }

  handleDateChange = date => {
    this.selectedDate = date
  }

  changeStatusComment = action(statusComment => {
    this.eplStatusComment = statusComment
  })

  closeModal = () => {
    this.props.close ? this.props.close() : this.props.modalStore.close()
    this.props.eplModel.get()
  }

  toggleOverrideDate = e => {
    this.shouldOverrideDate = !this.shouldOverrideDate
    if (!this.shouldOverrideDate) {
      this.selectedDate = null
    }
  }

  submit = async () => {
    if (this.shouldOverrideDate && !this.selectedDate) {
      this.error = 'Please select date!'
      return
    } else if (!this.eplStatusComment) {
      this.error = 'Please select status comment!'
      return
    } else {
      this.error = null
    }

    this.closeModal()
    try {
      if (this.props.eplModel.capiCall) {
        await capi.cancelCall(this.props.eplModel.epl.id, true)
      }

      await this.props.eplModel.handleCancellation({
        shouldOverrideDate: this.shouldOverrideDate,
        eplStatusComment: this.eplStatusComment,
        date: this.shouldOverrideDate
          ? stringifyDate(this.selectedDate)
          : stringifyDate(this.defaultDate)
      })
    } catch (error) {
      console.error(error)
      this.props.growlStore.showError('Call cannot be cancelled')
    }
  }

  renderConfirm = () => {
    const className = this.shouldOverrideDate
      ? 'EPLStatusModal__dateBlur'
      : null
    return (
      <div className="EPLStatusModal__confirm">
        <h1>Confirm cancellation date</h1>
        <p>
          Please Confirm if the Cancellation date for this Expert is correct:
        </p>
        <strong className={className}>{formatDate(this.defaultDate)}</strong>
        <p>
          If this is correct, please click confirm, or change the date below:
        </p>
      </div>
    )
  }

  renderDateSelect = () => {
    return (
      <div className="EPLStatusModal__change">
        <Checkbox
          label="Change to "
          value={this.shouldOverrideDate}
          onChange={this.toggleOverrideDate}
        />
        <DatePicker
          short
          date={this.selectedDate}
          onChange={this.handleDateChange}
          disabled={!this.shouldOverrideDate}
        />
      </div>
    )
  }

  renderControls = () => {
    if (this.props.forbidCancel) {
      return (
        <Button onClick={this.submit} primary>
          Confirm
        </Button>
      )
    }

    return (
      <div>
        <Button onClick={this.submit} primary>
          Confirm
        </Button>
        <Button onClick={this.closeModal} secondary>
          Cancel
        </Button>
      </div>
    )
  }

  render() {
    const { eplStore } = this.props
    return (
      <div className="EPLStatusModal">
        <div
          style={{
            display: 'flex',
            flexDirection: window && window.outerWidth < 768 ? 'column' : 'row'
          }}>
          <div style={{ paddingRight: 25, flexShrink: 0 }}>
            {this.renderConfirm()}
            {this.renderDateSelect()}

            <div className="EPLStatusModal__dropdown">
              <Dropdown
                data-cy="status-comment-dropdown"
                selectedItem={this.eplStatusComment}
                itemToString={item => item && item.name}
                options={eplStore.nonInterviewedStatusComments}
                placeholder="Select status comment"
                onChange={this.changeStatusComment}
              />
            </div>

            {this.error ? (
              <span className="EPLStatusModal__error">{this.error}</span>
            ) : null}

            {this.renderControls()}
          </div>
          <div style={{ paddingTop: 70 }}>
            <InfoBox theme="yellow">
              Changing to <em>Not Interviewed</em> might trigger a{' '}
              <strong>cancellation email</strong> to the expert/client if the
              invite was sent from the platform.
            </InfoBox>
          </div>
        </div>
      </div>
    )
  }
}

EPLCancellationModal.propTypes = {
  close: propTypes.func,
  forbidCancel: propTypes.bool,
  eplModel: propTypes.object,
  eplStore: propTypes.object,
  modalStore: propTypes.object,
  growlStore: propTypes.object
}

export default inject(
  'eplStore',
  'modalStore',
  'growlStore'
)(observer(EPLCancellationModal))
